import './FeaturesSection.css';

const features = [
  {
    title: 'Multi-rail payouts',
    body: 'API, manual, bulk and scheduled payouts on IMPS, NEFT, RTGS and UPI. A real retry engine, idempotency by default and signed webhooks keep failures small and recoverable.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="43" height="43" viewBox="0 0 43 43" fill="none">
        <path d="M40.2498 1.91699L26.8332 40.2503L19.1665 23.0003L1.9165 15.3337L40.2498 1.91699Z" stroke="#0043FE" strokeWidth="3.83333" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
  },
  {
    title: 'Auto reconciliation',
    body: 'Auto reconciliation across bank, switch and merchant, with settlement and reconciliation reports out of the box.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46" fill="none">
        <path d="M44.0835 7.66699V19.167H32.5835" stroke="#0043FE" strokeWidth="3.83333" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M1.9165 38.333V26.833H13.4165" stroke="#0043FE" strokeWidth="3.83333" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M6.72754 17.2503C7.69961 14.5034 9.35171 12.0474 11.5297 10.1116C13.7077 8.17576 16.3405 6.82323 19.1826 6.18018C22.0247 5.53712 24.9833 5.6245 27.7825 6.43416C30.5817 7.24383 33.1301 8.74938 35.19 10.8103L44.0834 19.167" stroke="#0043FE" strokeWidth="3.83333" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M39.2723 28.7497C38.3003 31.4967 36.6482 33.9527 34.4702 35.8885C32.2922 37.8243 29.6594 39.1768 26.8173 39.8198C23.9752 40.4629 21.0166 40.3755 18.2174 39.5659C15.4182 38.7562 12.8698 37.2506 10.8098 35.1897L1.9165 26.833" stroke="#0043FE" strokeWidth="3.83333" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
  },
  {
    title: 'Instant settlement',
    body: 'T+0 settlement wherever the rail allows it. Funds reach the beneficiary the same day, with a clear, traceable status on every transaction.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46" fill="none">
        <path d="M23 40.25C32.5269 40.25 40.25 32.5269 40.25 23C40.25 13.4731 32.5269 5.75 23 5.75C13.4731 5.75 5.75 13.4731 5.75 23C5.75 32.5269 13.4731 40.25 23 40.25Z" stroke="#0043FE" strokeWidth="3.83333" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M23 13.417V23.0003L28.75 26.8337" stroke="#0043FE" strokeWidth="3.83333" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
  },
  {
    title: 'Multi-wallet ledger',
    body: 'Primary, Payout, Fee and Commission wallets, each backed by a double-entry ledger, daily snapshots and a full audit trail.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46" fill="none">
        <path d="M40.25 23V13.4167H9.58333C8.56667 13.4167 7.59165 13.0128 6.87276 12.2939C6.15387 11.575 5.75 10.6 5.75 9.58333C5.75 8.56667 6.15387 7.59165 6.87276 6.87276C7.59165 6.15387 8.56667 5.75 9.58333 5.75H36.4167V13.4167" stroke="#0043FE" strokeWidth="3.83333" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M5.75 9.58301V36.4163C5.75 37.433 6.15387 38.408 6.87276 39.1269C7.59165 39.8458 8.56667 40.2497 9.58333 40.2497H40.25V30.6663" stroke="#0043FE" strokeWidth="3.83333" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M34.4998 23C33.4832 23 32.5082 23.4039 31.7893 24.1228C31.0704 24.8416 30.6665 25.8167 30.6665 26.8333C30.6665 27.85 31.0704 28.825 31.7893 29.5439C32.5082 30.2628 33.4832 30.6667 34.4998 30.6667H42.1665V23H34.4998Z" stroke="#0043FE" strokeWidth="3.83333" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
  },
  {
    title: 'Merchant portal',
    body: 'Self-serve onboarding with KYB, multi-wallet views, API keys, webhook configuration, sandbox access and reporting.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46" fill="none">
        <path d="M36.4167 5.75H9.58333C7.46624 5.75 5.75 7.46624 5.75 9.58333V36.4167C5.75 38.5338 7.46624 40.25 9.58333 40.25H36.4167C38.5338 40.25 40.25 38.5338 40.25 36.4167V9.58333C40.25 7.46624 38.5338 5.75 36.4167 5.75Z" stroke="#0043FE" strokeWidth="3.83333" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M5.75 17.25H40.25" stroke="#0043FE" strokeWidth="3.83333" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M17.25 40.25V17.25" stroke="#0043FE" strokeWidth="3.83333" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
  },
  {
    title: 'Compliance & KYC',
    body: 'PMLA-aware monitoring, KYB onboarding and published grievance redressal, with a named nodal officer and a clear escalation path.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46" fill="none">
        <path d="M23.0001 42.1663C23.0001 42.1663 38.3334 34.4997 38.3334 22.9997V9.58301L23.0001 3.83301L7.66675 9.58301V22.9997C7.66675 34.4997 23.0001 42.1663 23.0001 42.1663Z" stroke="#0043FE" strokeWidth="3.83333" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M17.25 23.0003L21.0833 26.8337L28.75 19.167" stroke="#0043FE" strokeWidth="3.83333" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
  },
];

export default function FeaturesSection() {
  return (
    <section className="features">
      <div className="features__container">
        <div className="features__header">
          <p className="features__eyebrow">Core features</p>
          <h2 className="features__heading">Payouts, reconciliation and settlement in one platform</h2>
          <p className="features__subheading">Six products on one ledger and one API.</p>
        </div>

        <div className="features__grid">
          {features.map((feature, i) => (
            <article key={i} className="features__card">
              <div className="features__icon">{feature.icon}</div>
              <h3 className="features__card-title">{feature.title}</h3>
              <p className="features__card-body">{feature.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
